var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { useCallback } from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { formRequest } from '@nordvpn/teams.core/lib/tools/api';
import ResetPasswordTemplate from 'components/templates/ResetPassword';
import { usePasswordReset } from 'api/Auth/mutators';
import { jsx as _jsx } from "react/jsx-runtime";
var ResetPasswordContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .reset-password-header {\n    color: #373b42;\n    margin-bottom: 8px;\n  }\n\n  .reset-password-form-subtitle,\n  .nord-input__label {\n    color: #72757a;\n  }\n\n  .reset-password-success-alert {\n    margin-top: 16px;\n  }\n"])));
export var ResetPassword = function ResetPassword() {
    var _usePasswordReset = usePasswordReset(), resetPassword = _usePasswordReset.mutateAsync, isLoading = _usePasswordReset.isLoading;
    var _useParams = useParams(), code = _useParams.code;
    var handleSubmit = useCallback(function (_ref) {
        var password = _ref.password;
        return formRequest(function () {
            return resetPassword({
                token: code,
                password: password
            });
        });
    }, [resetPassword, code]);
    return /*#__PURE__*/ _jsx(ResetPasswordContainer, {
        children: /*#__PURE__*/ _jsx(ResetPasswordTemplate, {
            isSubmitting: isLoading,
            onSubmit: handleSubmit
        })
    });
};
